const globalData = {

}

export default globalData;